import React from 'react';
import css from './PlanningRefMatchPopup.module.css';

const PlanningRefMatchPopup = ({ matched, planningRef, onDismiss }) => {
  return (
    <div className={css.overlay}>
      <div className={css.popup}>
        <button className={css.closeBtn} onClick={onDismiss} aria-label="Dismiss">✕</button>

        {matched ? (
          <>
            <div className={css.icon}>✅</div>
            <h3 className={css.title}>Planning application found!</h3>
            <p className={css.body}>
              We matched your reference <span className={css.ref}>{planningRef}</span> to a project in our database.
              Suppliers in your area will be notified.
            </p>
          </>
        ) : (
          <>
            <div className={css.icon}>🔍</div>
            <h3 className={css.title}>Reference not found yet</h3>
            <p className={css.body}>
              We couldn't find <span className={css.ref}>{planningRef}</span> in our database yet.
              Don't worry — we'll automatically match it as soon as it's ingested.
            </p>
          </>
        )}

        <button className={css.dismissBtn} onClick={onDismiss}>Got it</button>
      </div>
    </div>
  );
};

export default PlanningRefMatchPopup;
